document.addEventListener('DOMContentLoaded', function () {
  var mainCarousel = new Splide('#product-carousel', {});
  var thumbnailsCarousel = new Splide('#thumbnails-carousel', {});
  mainCarousel.sync(thumbnailsCarousel).mount();
  thumbnailsCarousel.mount();
  const modalHTML = `
    <div class="modal-overlay"></div>
    <div class="modal-content">
      <button class="modal-close">&times;</button>
      <div class="modal-main-image-wrapper">
        <img class="modal-main-image" src="" alt="main image">
      </div>
      <div class="modal-thumbnails"></div>
    </div>
  `;
  const modal = document.createElement('div');
  modal.id = 'image-modal';
  modal.style.display = 'none';
  modal.innerHTML = modalHTML;
  document.body.appendChild(modal);

  const mainImageEl   = modal.querySelector('.modal-main-image');
  const thumbsWrapper = modal.querySelector('.modal-thumbnails');
  const allImages     = Array.from(document.querySelectorAll('.product-media--wrapper img'));
  const productImages = allImages.filter(img =>
    window.productImageUrls && window.productImageUrls.some(url => img.src.includes(url) || img.getAttribute('data-src')?.includes(url))
  );

  productImages.forEach((img, i) => {
    const src = img.src || img.getAttribute('data-src');
    const thumb = document.createElement('img');
    thumb.src           = src;
    thumb.className     = 'modal-thumb';
    thumb.dataset.index = i;
    thumbsWrapper.appendChild(thumb);
    new Image().src = src;

    thumb.addEventListener('click', () => {
      showModal(src);
    });
  });

  
  let currentActiveSrc = '';
  function showModal(src) {
    mainImageEl.src = src;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  modal.querySelector('.modal-close').addEventListener('click', closeModal);
  modal.querySelector('.modal-overlay').addEventListener('click', closeModal);

  function updateActiveImageCache() {
    const img = document.querySelector('#product-carousel .splide__slide.is-active img');
    
    let src = img.src;
    if (!src || src.includes('data:')) {
      src = img.getAttribute('data-src');
    }
    
    if (src && src.startsWith('//')) {
      src = window.location.protocol + src;
    }
    currentActiveSrc = src;

    new Image().src = currentActiveSrc;
    modal.querySelectorAll('.modal-thumb')
      .forEach(t => t.classList.toggle('active', t.src === currentActiveSrc));
    mainImageEl.src = currentActiveSrc;
  }

  mainCarousel.on('mounted', () => { console.log('🔄 Splide mounted event'); updateActiveImageCache(); });
  mainCarousel.on('moved',   () => { console.log('🔄 Splide moved event');   updateActiveImageCache(); });
  updateActiveImageCache();

  document.querySelectorAll('#product-carousel .splide__slide img, .u-product-image--click')
    .forEach(el => {
      el.addEventListener('click', () => {
        if (currentActiveSrc) {
          showModal(currentActiveSrc);
        }
      });
    });
});



